import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import FirebaseAuthService from "../../firebase/FirebaseAuthService";

export default function Register() {

    const navigate = useNavigate();
    const [data, setData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        password: "",
        falahOrProf: "F",
    });

      const { t } = useTranslation();

    const [errorMessage, setErrorMessage] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessage({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage({});
        try {
            const login =
                await FirebaseAuthService.registerWithEmail(data);
            toast.success("Compte créé avec succès.");
            navigate("/verify-email");
            window.location.reload();
        } catch (error) {
            console.error(error);
            switch (error.code) {
                case "auth/email-already-in-use":
                    setErrorMessage({
                        email:  t("connexion.emailAlreadyInUse")
                    });
                    break;
                case "auth/weak-password":
                    setErrorMessage({
                        password:
                             t("connexion.passwordMinLength")
                    });
                    break;
                case "auth/invalid-email":
                    setErrorMessage({
                        email:  t("connexion.invalidEmail")
                    });
                    break;
                case "auth/network-request-failed":
                    setErrorMessage({
                        global:
                            t("connexion.firebaseConnectionError")
                    });

                    break;

                default:

                    setErrorMessage({
                        global:
                            error.message || t("connexion.unknownError")
                    });

            }

        }

    };

    return (

        <div className="container mt-5">

            <div className="row justify-content-center">

                <div className="col-md-6">

                    <div className="card shadow">

                        <div className="card-body p-4">

                            <h3 className="text-center mb-4">
                                {t("connexion.createAccount")}
                            </h3>

                            <form onSubmit={handleSubmit}>

                                {/* Nom */}

                                <div className="mb-3">

                                    <label> {t("monProfile.fullName")}</label>

                                    <input
                                        type="text"
                                        name="fullName"
                                        className={`form-control ${
                                            errorMessage.fullName ? "is-invalid" : ""
                                        }`}
                                        value={data.fullName}
                                        onChange={handleChange}
                                        required
                                    />

                                    {errorMessage.fullName && (
                                        <div className="invalid-feedback">
                                            {errorMessage.fullName}
                                        </div>
                                    )}

                                </div>

                                {/* Email */}

                                <div className="mb-3">

                                    <label> {t("monProfile.email")}</label>

                                    <input
                                        type="email"
                                        name="email"
                                        className={`form-control ${
                                            errorMessage.email ? "is-invalid" : ""
                                        }`}
                                        value={data.email}
                                        onChange={handleChange}
                                        required
                                    />

                                    {errorMessage.email && (
                                        <div className="invalid-feedback">
                                            {errorMessage.email}
                                        </div>
                                    )}

                                </div>

                                {/* Téléphone */}

                                <div className="mb-3">
                                    <label> {t("monProfile.phoneNumber")}</label>
                                    <input
                                        type="text"
                                        name="phoneNumber"
                                        className="form-control"
                                        value={data.phoneNumber}
                                        onChange={handleChange}
                                        required
                                    />

                                </div>

                                {/* Type */}
                                <div className="mb-3">
                                    <label className="form-label d-block">
                                        {t("monProfile.userType")}
                                    </label>
                                    <div className="d-flex gap-4">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="falahOrProf"
                                                value="F"
                                                checked={data.falahOrProf === "F"}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label">
                                                 {t("monProfile.farmer")}
                                            </label>

                                        </div>

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="falahOrProf"
                                                value="P"
                                                checked={data.falahOrProf === "P"}
                                                onChange={handleChange}
                                            />

                                            <label className="form-check-label">
                                                 {t("monProfile.professional")}
                                            </label>

                                        </div>

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="falahOrProf"
                                                value="S"
                                                checked={data.falahOrProf === "S"}
                                                onChange={handleChange}
                                            />

                                            <label className="form-check-label">
                                                 {t("monProfile.supplier")}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Password */}

                                <div className="mb-3">
                                    <label> {t("monProfile.password")} </label>
                                    <input
                                        type="password"
                                        name="password"
                                        className={`form-control ${
                                            errorMessage.password ? "is-invalid" : ""
                                        }`}
                                        value={data.password}
                                        onChange={handleChange}
                                        required
                                    />

                                    {errorMessage.password && (
                                        <div className="invalid-feedback">
                                            {errorMessage.password}
                                        </div>
                                    )}

                                </div>

                                {/* Erreur globale */}

                                {errorMessage.global && (
                                    <div className="alert alert-danger">
                                        {errorMessage.global}
                                    </div>
                                )}

                                <button
                                    className="btn btn-success w-100"
                                    type="submit"
                                >
                                     {t("connexion.signUp")}
                                </button>

                            </form>

                            <div className="text-center mt-3">
                                <span> {t("connexion.alreadyHaveAccount")}</span>
                                <Link
                                    to="/login"
                                    className="ms-2"
                                >
                                     {t("connexion.login")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}